import React, { createContext, useContext, useEffect, useState } from 'react';
import commonApi from '../utils/api';
import { useNavigate } from 'react-router-dom';
import { CommonContext } from './CommonContext';
import { format } from 'date-fns';
import { scrollToTop } from '../components/common/scrollToTop';

export const OrdersContextB2B = createContext();

const initialFilters = {
    searchBy: 'lrnum',
    searchValue: '',
    merchant_id: [],
    status: '',
    courier_id: [],
    delivery_type_id: '',
    order_status_id: [1],
    dateRange: {
        startDate: new Date(),
        endDate: new Date()
    },
    tab_id: 1,
};
const tabOptions = [
    { label: "Today Uploads", value: 1 },
    { label: "Manifest", value: 2 },
    { label: "NDR", value: 4 },
    { label: "In Transit", value: 5 },
    { label: "Delivered", value: 8 },
    { label: "OFD", value: 7 },
    { label: "Returned to Seller", value: 12 },
    { label: "Booking Failed", value: 21 },
    { label: "All Shipped Orders", value: 99 }
];
export const OrdersContextB2BProvider = ({ children }) => {
    const { user, alertMessage, setAlertMessage, openAlert, setOpenAlert, severity, setSeverity, globalSearch } = useContext(CommonContext);
    const navigate = useNavigate();

    const getInitialState = () => {
        const redirectFilters = localStorage.getItem('redirectFilters');
        if (redirectFilters) {
            const parsed = JSON.parse(redirectFilters);
            return {
                filters: { ...initialFilters, ...parsed },
                activeTab: parsed.tab_id
            };
        }
        return { filters: initialFilters, activeTab: tabOptions[0].value };
    };

    const initialState = getInitialState();
    const [filters, setFilters] = useState(initialState.filters);
    const [activeTab, setActiveTab] = useState(initialState.activeTab);
    const [addModal, setAddModal] = useState(false);
    const [osId, setOsId] = useState(1);
    const [isExportOpen, setIsExportOpen] = useState(false);
    const [selected, setSelected] = useState([]);
    const [allData, setAllData] = useState([]);
    const [allOrders, setAllOrders] = useState([]);
    const [firstLoading, setFirstLoading] = useState(false);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(50);
    const [cancelDialog, setCancelDialog] = useState(false);
    const [cancelRemarks, setCancelRemarks] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [details, setDetails] = useState();
    const [suborders, setSuborders] = useState([]);
    const [dimensionData, setDimensionData] = useState([]);
    const [invoiceData, setInvoiceData] = useState([]);

    const [isOpen, setIsOpen] = useState(false);
    const [openTracking, setOpenTracking] = useState(false);
    const [trackingInfo, setTrackingInfo] = useState(null);

    const handleAddModal = () => {
        setAddModal(true);
    };

    const handleCloseModal = () => {
        setAddModal(false);
    };
    const onCloseAlert = () => {
        setOpenAlert(false);
        setAlertMessage('');
        setSeverity('')
    };

    const handleToggleDrawer = () => {
        setIsOpen(!isOpen);
    };
    // console.log('filters', filters);
    const onLoadApi = (customFilters = filters) => {
        const payload = {
            ...customFilters,
            start_date: customFilters?.dateRange?.startDate
                ? format(new Date(customFilters.dateRange.startDate), 'yyyy-MM-dd')
                : null,
            end_date: customFilters?.dateRange?.endDate
                ? format(new Date(customFilters.dateRange.endDate), 'yyyy-MM-dd')
                : null,
        };
        if (activeTab === 99 && (!customFilters?.order_status_id || customFilters?.order_status_id?.length === 0)) {
            payload.order_status_id = [];
        }
        // if (globalSearch?.value) {
        //     payload.searchBy = 'awb_no';
        //     payload.searchValue = globalSearch?.value;
        //     payload.start_date = '';
        //     payload.end_date = '';
        //     setFilters((prev) => ({ ...prev, searchBy: 'awb_no', searchValue: globalSearch?.value, dateRange: { startDate: null, endDate: null } }));
        // }

        delete payload.dateRange;
        setAllData([]);
        setAllOrders([]);
        setFirstLoading(false);
        commonApi.post(`/orders/list-b2b?page=${page + 1}&per_page=${rowsPerPage}`, payload)
            .then((response) => {
                setFirstLoading(true);
                if (response?.data?.data) {
                    setAllOrders(response?.data?.data);
                    setAllData(response?.data);
                }
            })
            .catch((error) => {
                setFirstLoading(true);
                console.error('Error fetching data:', error);
            });
    };
    const onTracking = (id) => {
        setOpenTracking(false);
        setTrackingInfo(null);
        setIsLoading(true);
        commonApi.post('/orders/tracking-b2b', { order_ids: id })
            .then((response) => {
                setIsLoading(false);
                if (response?.data?.s === 1) {
                    setOpenTracking(true);
                    setTrackingInfo(response?.data?.data)
                } else {
                    setAlertMessage(response?.data?.msg);
                    setSeverity('error');
                    setOpenAlert(true);
                    scrollToTop();
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.error('Error fetching data:', error);
                setAlertMessage(error?.response?.data?.msg);
                setSeverity('error');
                setOpenAlert(true);
                scrollToTop();
            });
    }
    const viewDetail = (id) => {
        setDetails(null);
        setIsLoading(true);
        commonApi.post('/orders/view-b2b', { id: id })
            .then((response) => {
                setIsLoading(false);
                if (response?.data?.s === 1) {
                    setDetails(response?.data?.data);
                    const subordersArray = JSON.parse(response?.data?.data?.suborders_data);
                    const dimensionArray = JSON.parse(response?.data?.data?.dimension_data);
                    const invoiceArray = JSON.parse(response?.data?.data?.invoice_data);
                    if (subordersArray.length) {
                        setSuborders(subordersArray);
                    }
                    if (dimensionArray.length) {
                        setDimensionData(dimensionArray);
                    }
                    if (invoiceArray.length) {
                        setInvoiceData(invoiceArray)
                    }
                    handleToggleDrawer();
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.error('Error fetching data:', error);
            });
    }

    // Fetch initial data when the context is created
    useEffect(() => {
        localStorage.removeItem('redirectFilters');
    }, []);

    useEffect(() => {
        const customFilters = { ...filters };
        if (globalSearch?.value) {
            customFilters.searchBy = 'lrnum';
            customFilters.searchValue = globalSearch?.value;
            customFilters.start_date = '';
            customFilters.end_date = '';
            customFilters.order_status_id = [];
            customFilters.tab_id = 99;
            customFilters.dateRange = { startDate: null, endDate: null };
            setFilters((prev) => ({ ...prev, order_status_id: [99], tab_id: 99, searchBy: 'lrnum', searchValue: globalSearch?.value, dateRange: { startDate: null, endDate: null } }));
            setActiveTab(99);
        }
        onLoadApi(customFilters);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [page, rowsPerPage, activeTab, globalSearch?.searchTrigger]);

    const onCancelOrder = () => {
        setIsLoading(true);
        commonApi.post('/orders/cancel-orders-b2b', { "order_ids": selected.join(', '), "remarks": cancelRemarks })
            .then((response) => {
                setIsLoading(false);
                setOpenAlert(true);
                if (response?.data?.s === 0) {
                    setAlertMessage(response?.data?.msg);
                    setSeverity('error')
                } else {
                    setAlertMessage(response?.data?.msg);
                    setSeverity('success');
                    setCancelRemarks('');
                    setSelected([]);
                    setCancelDialog(false);
                    onLoadApi();
                }
            })
            .catch((error) => {
                setIsLoading(false);
                setOpenAlert(true);
                setAlertMessage(error.response?.data?.msg);
                setSeverity('error')
                console.error('Error fetching data:', error);
            });
    };
    const recheckStatus = () => {
        setIsLoading(true);
        commonApi.post('/cron/tracking-b2b', { "order_ids": selected.join(', ') })
            .then((response) => {
                setIsLoading(false);
                setOpenAlert(true);
                if (response?.data?.s === 0) {
                    setAlertMessage(response?.data?.msg);
                    setSeverity('error')
                } else {
                    setAlertMessage(response?.data?.msg);
                    setSeverity('success');
                    setCancelRemarks('');
                    setSelected([]);
                    setCancelDialog(false);
                    onLoadApi();
                }
            })
            .catch((error) => {
                setIsLoading(false);
                setOpenAlert(true);
                setAlertMessage(error.response?.data?.msg);
                setSeverity('error')
                console.error('Error fetching data:', error);
            });
    };
    const onLabelGen = (labe_type = null) => {
        setIsLoading(true);
        let postReq = { "order_ids": labe_type ? details?.id : selected.join(', '), size: labe_type ?? null };
        if (user?.user_type === "Merchant") {
            postReq.merchant_id = user?.id
        } else {
            postReq.admin_id = user?.id
        }
        commonApi.post('/orders/generate-address-labels-b2b', postReq)
            .then((response) => {
                setIsLoading(false);
                setOpenAlert(true);
                if (response?.data?.s === 0) {
                    setAlertMessage(response?.data?.msg);
                    setSeverity('error')
                } else {
                    setAlertMessage(response?.data?.msg);
                    setSeverity('success');
                    setSelected([]);
                    onLoadApi();
                    setTimeout(() => {
                        navigate('/download');
                    }, 3000);
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.error('Error fetching data:', error);
            });
    };
    const onBulkPOD = () => {
        setIsLoading(true);
        commonApi.post('/orders/generate-bulk-pod-b2b', { "order_ids": selected.join(', ') })
            .then((response) => {
                setIsLoading(false);
                setOpenAlert(true);
                if (response?.data?.s === 0) {
                    setAlertMessage(response?.data?.msg);
                    setSeverity('error')
                } else {
                    setAlertMessage(response?.data?.msg);
                    setSeverity('success');
                    setSelected([]);
                    onLoadApi();
                    setTimeout(() => {
                        navigate('/download');
                    }, 3000);
                }
            })
            .catch((error) => {
                setAlertMessage(error?.response?.data?.msg || error?.message || 'Something went wrong');
                setOpenAlert(true);
                setSeverity('error');
                setIsLoading(false);
                console.error('Error fetching data:', error);
            });
    };
    const onInvoiceGen = () => {
        setIsLoading(true);
        commonApi.post('/orders/generate-product-invoices-b2b', { "order_ids": selected.join(', ') })
            .then((response) => {
                setIsLoading(false);
                setOpenAlert(true);
                if (response?.data?.s === 0) {
                    setAlertMessage(response?.data?.msg);
                    setSeverity('error')
                } else {
                    setAlertMessage(response?.data?.msg);
                    setSeverity('success');
                    setSelected([]);
                    onLoadApi();
                    setTimeout(() => {
                        navigate('/download');
                    }, 3000);
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.error('Error fetching data:', error);
            });
    };
    const onManifestGen = () => {
        setIsLoading(true);
        commonApi.post('/orders/generate-manifest-b2b', { "order_ids": selected.join(', ') })
            .then((response) => {
                setIsLoading(false);
                setOpenAlert(true);
                if (response?.data?.s === 0) {
                    setAlertMessage(response?.data?.msg);
                    setSeverity('error')
                } else {
                    setAlertMessage(response?.data?.msg);
                    setSeverity('success');
                    setSelected([]);
                    onLoadApi();
                    setTimeout(() => {
                        navigate('/download');
                    }, 3000);
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.error('Error fetching data:', error);
            });
    };
    const downLoadPod = (id) => {
        setIsLoading(true);
        commonApi.post('/orders/generate-epod-b2b', { "order_ids": id })
            .then((response) => {
                setIsLoading(false);
                setOpenAlert(true);
                if (response?.data?.s === 0) {
                    setAlertMessage(response?.data?.msg);
                    setSeverity('error')
                } else {
                    setAlertMessage(response?.data?.msg);
                    setSeverity('success');
                    // setSelected([]);
                    // onLoadApi();
                    setTimeout(() => {
                        navigate('/download');
                    }, 3000);
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.error('Error fetching data:', error);
            });
    };
    const onShip = () => {
        setIsLoading(true);
        commonApi.post('/orders/ship-b2b', { "order_ids": selected.join(', ') })
            .then((response) => {
                setIsLoading(false);
                setOpenAlert(true);
                if (response?.data?.s === 0) {
                    setAlertMessage(response?.data?.msg);
                    setSeverity('error')
                } else {
                    setAlertMessage(response?.data?.msg);
                    setSeverity('success');
                    setSelected([]);
                    onLoadApi();
                    // handleOpenShipModal();
                    // setShippingData(response?.data?.allREsponse);
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.error('Error fetching data:', error);
            });
    };
    const onExport = (columns) => {
        let payload = {
            ...filters,
            start_date: filters?.dateRange?.startDate
                ? format(new Date(filters.dateRange.startDate), 'yyyy-MM-dd')
                : null,
            end_date: filters?.dateRange?.endDate
                ? format(new Date(filters.dateRange.endDate), 'yyyy-MM-dd')
                : null,
        };
        if (user?.user_type !== "Merchant") {
            payload.admin_id = user?.id
        }
        if (selected.length > 0) {
            payload.order_ids = selected.join(', ')
        }
        if (columns?.length) payload.columns = columns

        delete payload.dateRange;
        setIsLoading(true);
        commonApi.post('/orders/export-b2b', payload)
            .then((response) => {
                setIsLoading(false);
                setOpenAlert(true);
                if (response?.data?.s === 0) {
                    setAlertMessage(response?.data?.msg);
                    setSeverity('error')
                } else {
                    navigate('/download');
                    setIsExportOpen(false);
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.error('Error fetching data:', error);
                setOpenAlert(true);
                setAlertMessage(error?.response?.data?.msg);
                setSeverity('error')
            });
    };

    const contextValue = {
        suborders,
        dimensionData,
        invoiceData,
        addModal,
        handleAddModal,
        handleCloseModal,
        trackingInfo,
        openTracking,
        setOpenTracking,
        onTracking,
        isOpen,
        setIsOpen,
        handleToggleDrawer,
        viewDetail,
        details,
        initialFilters,
        osId,
        setOsId,
        allData,
        setAllData,
        allOrders,
        setAllOrders,
        page,
        setPage,
        rowsPerPage,
        setRowsPerPage,
        firstLoading,
        setFirstLoading,
        cancelDialog,
        setCancelDialog,
        isLoading,
        setIsLoading,
        onLoadApi,
        selected,
        setSelected,
        tabOptions,
        activeTab,
        setActiveTab,
        filters,
        setFilters,
        onCancelOrder,
        onExport,
        isExportOpen,
        setIsExportOpen,
        recheckStatus,
        downLoadPod,
        onManifestGen,
        onInvoiceGen,
        onLabelGen,
        onBulkPOD,
        onShip,
    };
    return (
        <OrdersContextB2B.Provider value={contextValue}>
            {children}
        </OrdersContextB2B.Provider>
    );
};

